import { JWT } from '@/constants'

export class LocalStorageService {
  public static getAccessToken(): string | null {
    return localStorage.getItem(JWT)
  }

  public static setToken(token?: string) {
    if (token) {
      localStorage.setItem(JWT, token)
    } else {
      this.clearToken()
    }
  }

  public static clearToken() {
    localStorage.removeItem(JWT)
  }
}
